module.exports = __webpack_public_path__ + "res/24-img_other_action.fced5d1842a305363cbaea43568c2bd1.png";